

function SplashView() {
    return (
        <>
            <div className="fixed top-0 flex w-[100%] h-[100%] justify-center items-center">
                <img src="/imgs/introback.png" alt="" className="w-full h-[100%]justify-center items-center" />
                <div className="absolute w-full h-full flex justify-center items-center">
                    {/* <img src="/imgs/borderLogo.png" alt="" className="absolute flex justify-center items-center" /> */}
                    <img className="w-[50%]" src="/splash.gif" alt="logo" />
                </div>
                {/* <div className="absolute mt-[450px]">
                    <div className="flex">
                        <img src="/imgs/textView1.png" alt="" />
                        <img src="/imgs/textView2.png" alt="" />
                    </div>
                    <div className="flex mr-8">
                        <img src="/imgs/dotText1.png" alt="" className="" />
                        <img src="/imgs/dotText2.png" alt="" />
                    </div>
                </div> */}
            </div>
        </>
    )
}

export default SplashView;